import * as React from "react";
import { useState, useEffect } from "react";
import { Button, KIND } from "baseui/button";
import { Input} from "baseui/input";
import { useStyletron, styled } from "baseui";
import { AuthForm } from "./AuthForm";
const StyledLink = styled("a", ({ $theme }) => ({
  textDecoration: "none",
  color: $theme.colors.primary,
  cursor: "pointer",
  ":hover": {
    textDecoration: "underline",
  },
}));
function SignUpView(props) {
  const [css, theme] = useStyletron();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassowrd, setConfirmPassowrd] = useState("");
  const [error, setError] = useState(props.error);
  const [isLoading, setIsLoading] = useState(props.isLoading);
  const [email, setEmail] = useState("");

  useEffect(() => {
    setError(props.error);
    setIsLoading(props.isLoading);
  }, [props.error, props.isLoading]);

  const validateUsername = (username) => {
    const regex = /^[A-Za-z0-9_]+$/; // regex for no spaces and no special characters
    return regex.test(username);
  };

  const validatePassword = (password) => {
    return password.length > 0; // simple check for non-empty password
  };

  const validateConfirmPassword = (password, confirmPassword) => {
    return password === confirmPassword;
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // simple email format validation
    return regex.test(email);
  };

  const handleSignUp = () => {
    if (!validateUsername(username)) {
      setError("Username should not contain spaces or special characters.");
      return;
    }
    if (!validatePassword(password)) {
      setError("Password should not be empty.");
      return;
    }
    if (!validateConfirmPassword(password, confirmPassowrd)) {
      setError("Passwords do not match.");
      return;
    }
    if (!validateEmail(email)) {
      setError("Invalid email address.");
      return;
    }
    setError(""); // clear previous errors
    props.onCreateAccount(username, password, email);
  };
  return (

        <AuthForm error={error} isLoading={props.isLoading}>
          <div className={css({ marginBottom: theme.sizing.scale600 })}>
            <Input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username"
              clearable
            />
          </div>
          <div className={css({ marginBottom: theme.sizing.scale600 })}>
            <Input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              type="password"
              clearable
            />
          </div>
          <div className={css({ marginBottom: theme.sizing.scale600 })}>
            <Input
              value={confirmPassowrd}
              onChange={(e) => setConfirmPassowrd(e.target.value)}
              placeholder="Confirm Password"
              type="password"
              clearable
            />
          </div>
          <div className={css({ marginBottom: theme.sizing.scale600 })}>
            <Input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter Email"
              clearable
            />
          </div>
          <div className={css({ marginBottom: theme.sizing.scale600 })}>
            <Button
              kind={KIND.primary}
              onClick={handleSignUp}
              isLoading={isLoading}
              overrides={{
                BaseButton: { style: { width: "100%" } },
              }}
            >
              {isLoading ? "Creating Account..." : "Create Account"}
            </Button>
          </div>
          <div
            className={css({
              display: "flex", // Use flexbox
              flexDirection: "column", // Stack items vertically
              alignItems: "center", // Center horizontally
              marginBottom: theme.sizing.scale600,
            })}
          >
            <div>
              <span> Already on Templize? </span>
              <StyledLink onClick={props.onNavigateToSignIn}>Sign in</StyledLink>
            </div>
          </div>
        </AuthForm>
  );
}
export default SignUpView;
